import type { RoutesPlannerRun, RoutesPlannerTask } from '../../types';
import type { RoutesPlannerBreak } from '../../components/routes-planner/routes-planner';
import type { EtaResponseRouteItem } from '@bringg-frontend/eta-calculator';
import type { Driver } from '@bringg/types';
import type ConsecutiveRoutesStore from '../../stores/consecutive-routes/consecutive-routes-store';
import { toJS } from 'mobx';
import { etaRoutesConverter } from '../eta/eta-routes-converter';

const prepareData = (
	runsToTasks: { [runId: number]: RoutesPlannerTask[] },
	runsToBreaks: { [runId: number]: RoutesPlannerBreak[] },
	routesInfoByIndex: { [runId: number]: EtaResponseRouteItem },
	runsToDriver: { [runId: number]: Driver },
	consecutiveRoutesStore: ConsecutiveRoutesStore,
	consecutiveRoutesEnabled: boolean
) => {
	let runToTasks: { [runId: number]: RoutesPlannerTask[] } = toJS(runsToTasks);
	let runToBreaks: { [runId: number]: RoutesPlannerBreak[] } = toJS(runsToBreaks);
	let routeInfoByIndex: { [runId: number]: EtaResponseRouteItem } = toJS(routesInfoByIndex);
	let runToDriver: { [runId: number]: Driver } = toJS(runsToDriver);

	if (consecutiveRoutesEnabled) {
		runToTasks = Object.assign({}, runToTasks, toJS(consecutiveRoutesStore.routesTasksByRouteId));
		runToBreaks = Object.assign({}, runToBreaks, toJS(consecutiveRoutesStore.runToBreaks));
		runToDriver = Object.assign({}, runToDriver, toJS(consecutiveRoutesStore.routesToDriver));

		const routesById: RoutesPlannerRun[] = Array.from(toJS(consecutiveRoutesStore.routesById).values());
		const convertedRoutesToEtaResponseRoutes: EtaResponseRouteItem[] = routesById.map(route =>
			etaRoutesConverter.routeToEtaResponseItem(route)
		);
		const etaResponseRoutesById: { [runId: number]: EtaResponseRouteItem } = Object.fromEntries(
			convertedRoutesToEtaResponseRoutes.map(route => [route.run_id, route])
		);
		routeInfoByIndex = Object.assign({}, routesInfoByIndex, etaResponseRoutesById);
	}

	return {
		runToTasks,
		runToBreaks,
		routeInfoByIndex,
		runToDriver
	};
};

export const optimizationSavingData = { prepareData };
